/** True while a background job (transcript, report, translation) is queued or running. */
export const isRunningStatus = (status) => status === 'PENDING' || status === 'PROCESSING';
